export var NetPositionsMapper = function (data) {
    var result = {
        data: {},
    };
    if (data && data.data) {
        result.data.netMTM = data.data.ntMTM;
        result.data.openPositions = data.data.opn;
        result.data.totalPositions = data.data.npos;
        result.data.unRealisedMtm = data.data.urlMtm;
        result.data.pos = data.data.pos;
    }
    return result;
};
